function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { contactLists as contactListsService } from "../../services";
export var createContactList = function createContactList(contactList) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var state, result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              _context.next = 3;
              return contactListsService.createContactList(contactList, state.app.language);

            case 3:
              result = _context.sent;
              return _context.abrupt("return", dispatch({
                type: 'CREATE_CONTACT_LIST',
                result: result
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var updateContactList = function updateContactList(contactList) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var state, data;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              _context2.next = 3;
              return contactListsService.updateContactList(contactList, state.app.language);

            case 3:
              data = _context2.sent;
              return _context2.abrupt("return", dispatch({
                type: 'UPDATE_CONTACT_LIST',
                data: data
              }));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var deleteContactList = function deleteContactList(id) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
      var result;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return contactListsService.deleteContactList(id);

            case 2:
              result = _context3.sent;
              return _context3.abrupt("return", dispatch({
                type: 'DELETE_CONTACT_LIST',
                result: result
              }));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var removeSharedContactList = function removeSharedContactList(id) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch) {
      var result;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return contactListsService.removeSharedContactList(id);

            case 2:
              result = _context4.sent;
              dispatch({
                type: 'REMOVE_SHARED_CONTACTS',
                result: result
              });

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x6) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var getContactList = function getContactList(id) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch) {
      var result;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return contactListsService.getContactList(id);

            case 2:
              result = _context5.sent;
              return _context5.abrupt("return", result);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x7) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var getContactLists = function getContactLists(wildcard) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch) {
      var _yield$contactListsSe, data;

      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return contactListsService.getContactLists(wildcard);

            case 2:
              _yield$contactListsSe = _context6.sent;
              data = _yield$contactListsSe.data;
              return _context6.abrupt("return", dispatch({
                type: 'GET_CONTACT_LISTS',
                data: data
              }));

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x8) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var getContactListContacts = function getContactListContacts(id) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch) {
      var result;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return contactListsService.getContactListContacts(id);

            case 2:
              result = _context7.sent;
              return _context7.abrupt("return", result);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x9) {
      return _ref7.apply(this, arguments);
    };
  }();
};
export default {
  createContactList: createContactList,
  updateContactList: updateContactList,
  getContactList: getContactList,
  getContactLists: getContactLists,
  deleteContactList: deleteContactList,
  removeSharedContactList: removeSharedContactList,
  getContactListContacts: getContactListContacts
};